import Bugsnag from '@bugsnag/js'
import store from 'base/store'
import { addAsyncScript } from 'base/lib/addScript'
import Event from 'base/event'
import Hub from 'base/hub'

function initPixlee() {
  return addAsyncScript('https://assets.pixlee.com/assets/pixlee_events.js')
    .then(() => {
      if (window.Pixlee_Analytics) {
        window.pixlee_analytics = new window.Pixlee_Analytics(
          store.getState().appConfig.pixlee?.accountApiKey,
        )
      }
    })
    .catch(() => {
      // no-op, we don't need to log when the Pixlee script fails to load
      // because it happens all the time.
    })
}

function firePixleeEvent(event, data) {
  if (typeof pixlee_analytics !== 'undefined') {
    try {
      window.pixlee_analytics.events.trigger(event, {
        ...data,
      })
    } catch (err) {
      Bugsnag.notify(err)
    }
  }
}

function firePixleeAddToCart(event, data) {
  firePixleeEvent('add:to:cart', {
    product_sku: data.variant.sku,
    price: data.variant.price.toString(),
    quantity: 1,
    currency: 'USD',
  })
}

function setupPixlee() {
  if (!store.getState().appConfig.isProductionLike) {
    return
  }

  try {
    initPixlee()
  } catch {
    return false
  }

  Hub.sub(Event.Checkout.ADD_TO_CART, firePixleeAddToCart, { late: true })
}

export default setupPixlee
